export default function ToggleButton(theme) {
    const disabledStyle = {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200]
        }
    };

    return {
        MuiToggleButton: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    fontWeight: 400,
                    '&.MuiToggleButton-sizeSmall': {
                        padding: 5,
                        lineHeight: 2
                    }
                },
                contained: {
                    ...disabledStyle
                },
                outlined: {
                    ...disabledStyle
                }
            }
        }
    };
}
